const ROOT = 'dashboard/settings/location/states';

export default {
	arrayList: `${ROOT}/list`,
	arrayListToDropdown: `${ROOT}/by-country/`,
	store: `${ROOT}`,
	show: `${ROOT}/`,
	status: `${ROOT}/status/`,
	update: `${ROOT}/`,
	destroy: `${ROOT}/`,
};
